import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {
  AssociateOptionCategoryPayload, CategoryOrderUpdatePayload,
  CubicleOption,
  CubicleOptionValue,
  EditCategoryPayload, OptionOrderUpdatePayload,
} from '../../../../shared/model/cubicleOption-model';
import {Range} from "../../../../shared/model/range-model";
import {TreeNode} from "primeng/api";
import {Reference} from "../../../../configuration/shared/model/reference";
import {OdmEditCategoryModalComponent} from "../odm-edit-category-modal/odm-edit-category-modal.component";
import {Category} from "../../../../configuration/shared/model/IProduct";
import {
  OdmEditCategoryAssignationModalComponent
} from "../odm-edit-category-assignation-modal/odm-edit-category-assignation-modal.component";

@Component({
  standalone: false,
  selector: 'app-odm-manage-option',
  templateUrl: './odm-manage-option.component.html',
  styleUrls: ['./odm-manage-option.component.scss']
})
export class OdmManageOptionComponent implements OnInit, OnChanges {

  @ViewChild('editCategoryModal') editCategoryModal: OdmEditCategoryModalComponent;
  @ViewChild('editCategoryAssignationModal') editCategoryAssociationModal: OdmEditCategoryAssignationModalComponent;

  @Input()
  activeReference: string;

  @Input()
  options: Map<string, CubicleOption[]>;

  @Input()
  references: Reference[] = [];

  @Input()
  showOnPopUpStatus: boolean = true;

  @Input()
  selectedRange: Range;

  @Output()
  clickEditOptionButton: EventEmitter<CubicleOption> = new EventEmitter<CubicleOption>();

  @Output()
  clickEditCategoryName: EventEmitter<EditCategoryPayload> = new EventEmitter<EditCategoryPayload>();

  @Output()
  clickEditCategoryAssociation: EventEmitter<AssociateOptionCategoryPayload> = new EventEmitter<AssociateOptionCategoryPayload>();

  @Output()
  clickDeleteCategoryAssociation: EventEmitter<AssociateOptionCategoryPayload> = new EventEmitter<AssociateOptionCategoryPayload>();

  @Output()
  clickEditOptionValueButton: EventEmitter<{
    option: CubicleOption,
    optionValue: CubicleOptionValue
  }> = new EventEmitter<{ option: CubicleOption, optionValue: CubicleOptionValue }>();

  @Output()
  clickDeleteOptionValueButton: EventEmitter<{
    option: CubicleOption,
    optionValue: CubicleOptionValue
  }> = new EventEmitter<{ option: CubicleOption, optionValue: CubicleOptionValue }>();


  @Output()
  changeCategoryOrderEvent = new EventEmitter<CategoryOrderUpdatePayload>();

  @Output()
  changeOptionOrderEvent = new EventEmitter<OptionOrderUpdatePayload>();

  optionsData: TreeNode[] = [];

  cols = [
    {label: 'T_COMPONENT_REFERENCE_COLUMN', field: 'switchboardComponent', styleClass: 'text-left col-xs-2 col-category'},
    {label: 'T_ACCESSORY_CATEGORY', field: 'category', styleClass: 'text-left col-xs-2 col-category'},
    {label: 'T_OPTIONS_TITLE', field: 'name', styleClass: 'text-left col-xs-2 col-category'},
    {label: 'T_OFFER_DATA_MANAGEMENT_OPTION_VALUE_INFORMATION', field: 'valueName', styleClass: 'text-left col-xs-1'},
    {label: 'T_OPTION_VALUE_REFERENCE', field: 'reference', styleClass: 'text-left col-xs-1'}
  ];
  toExpand = true;
  selectedCategoryId: string;
  selectedCategory: Category;

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.references) {
      this.createComponentsNode();
    }
  }

  ngOnInit(): void {
    this.createComponentsNode();
  }

  onClickEditCategoryButton(category) {
    let categories: Category[] = this.options.get(category.parent.data.componentReference).map(option => option.category);
    this.activeReference = category.parent.data.componentReference;
    const findCategories = categories.filter(cat => cat !== null && cat.id === category.node.data.category);
    if (findCategories === null || findCategories.length === 0) {
      return;
    }
    this.selectedCategoryId = category.node.data.category;
    let categoryUsageList: string[] = [];
    this.options.forEach(function (value, key) {
      const categoryIds = value.map(opt => opt?.category?.id);
      if (categoryIds.includes(category.node.data.category)) {
        categoryUsageList.push(" " + key);
      }
    });
    this.editCategoryModal.show(findCategories[0].name, categoryUsageList);
  }

  onClickEditCategoryAssociationButton(category) {
    let categories: Category[] = this.options.get(category.parent.data.componentReference).map(option => option.category);
    this.activeReference = category.parent.data.componentReference;
    const findCategories = categories.filter(cat => cat !== null && cat.id === category.node.data.category);
    if (findCategories === null || findCategories.length === 0) {
      const selectedOptionIds = category.node.children.map(child => child.data.id);
      this.editCategoryAssociationModal.show(this.selectedRange.id, null, selectedOptionIds);
      return;
    }
    this.selectedCategoryId = category.node.data.category;
    this.selectedCategory = findCategories[0];
    const selectedOptionIds = category.node.children.map(child => child.data.id);
    this.editCategoryAssociationModal.show(this.selectedRange.id, findCategories[0], selectedOptionIds);
  }

  onClickDeleteCategoryButton(category) {
    const componentRef = category.parent.data.componentReference;
    const categoryId = category.node.data.category === '-' ? null : category.node.data.category;
    const payload: AssociateOptionCategoryPayload = {
      options: [],
      component: componentRef,
      categoryId: categoryId,
      rangeId: this.selectedRange.id
    };
    this.clickDeleteCategoryAssociation.emit(payload);
  }

  public isExpanded(node: any): boolean {
    return node.node !== null && node.node.expanded === true;
  }

  public toggleExpand() {
    if (this.optionsData && this.optionsData.length > 0) {
      const newOptionData = [...this.optionsData];
      newOptionData.forEach(optionData => {
        optionData.expanded = this.toExpand;
        if (optionData.children) {
          optionData.children.forEach(child => {
            child.expanded = this.toExpand;
            if (child.children) {
              child.children.forEach(grandChild => {
                grandChild.expanded = this.toExpand;
              });
            }
          });
        }
      })
      this.optionsData = newOptionData;
      this.toExpand = !this.toExpand;
    }
  }

  public editCategoryName(event: EditCategoryPayload) {
    this.clickEditCategoryName.emit(event);
  }

  public editCategoryAssociation(event: AssociateOptionCategoryPayload) {
    event.component = this.activeReference;
    this.clickEditCategoryAssociation.emit(event);
  }

  private createComponentsNode() {
    let treeNodes: TreeNode[] = [];
    this.references.forEach(reference => treeNodes.push(this.createOptionsNode(reference)));
    this.optionsData = treeNodes;
    this.toExpand = true;
  }

  private createOptionsNode(reference: Reference): TreeNode {
    let treeNodes: TreeNode[] = [];
    const expanded = this.activeReference === reference.ref;
    this.createCategoryNodes(this.options.get(reference.ref), reference).forEach(node => treeNodes.push(node));
    return {
      data: {componentReference: reference.ref, componentDescription: reference.description, reference: null},
      type: 'component',
      expanded: expanded,
      children: treeNodes
    };
  }

   private createCategoryNodes(cubicleOptions: CubicleOption[], reference: Reference): TreeNode[] {
     const expanded = this.activeReference === reference.ref;
     let categoriesTreeNodes: TreeNode[] = [];
    const categoryGroups = Object.groupBy(cubicleOptions, ({category}) => category?.id);
    const categoryIds = [...new Set(cubicleOptions
      .filter(option => option.category !== null && option.category !== undefined)
      .sort((a, b) =>
        (a.category?.categoryOrderIndex ?? 0) - (b.category?.categoryOrderIndex ?? 0))
      .map(option => option.category?.id)
    )];
    const hasUndefined = !!categoryGroups['undefined'];
    let finalCategoryIds = [...categoryIds];
    if (hasUndefined) {
      finalCategoryIds = finalCategoryIds.filter(id => id !== 'undefined');
      finalCategoryIds.unshift('undefined');
    }
    finalCategoryIds.forEach(id => {
      let categoryTreeNodes: TreeNode[] = [];
      categoryGroups[id].forEach(cubicleOption => categoryTreeNodes.push(this.createOptionNode(cubicleOption, expanded)));
      categoriesTreeNodes.push({
        data: {
          categoryName: id === 'undefined' ? '-' : categoryGroups[id][0].category.name,
          category: id === 'undefined' ? '-' : id
        },
        type: 'category',
        expanded: expanded,
        children: categoryTreeNodes
      });
    });
    return categoriesTreeNodes;
  }

  public toggleReference(event) {
    if (this.optionsData && this.optionsData.length > 0) {
      const newOptionData = [...this.optionsData];
      newOptionData.forEach(optionData => {
        if (optionData.type === 'component' && optionData.data.componentReference === event.node.data.componentReference && optionData.children) {
          optionData.children.forEach(child => {
            child.expanded = event.node.expanded;
            if (child.children) {
              child.children.forEach(grandChild => {
                grandChild.expanded = event.node.expanded;
              });
            }
          });
        }
      })
      this.optionsData = newOptionData;
    }
  }

  private createOptionNode(option: CubicleOption, expanded: boolean): TreeNode {
    return {
      data: {
        id: option.id,
        name: option.name,
        description: option.description,
        mandatory: option.mandatory,
        onPopUp: option.onPopUp,
        reference: null
      },
      type: 'option',
      expanded: expanded,
      children: this.createOptionValuesNode(option.values, option.id)
    };
  }

  private createOptionValuesNode(values: CubicleOptionValue[], optionId: string): TreeNode[] {
    let treeNodes: TreeNode[] = [];
    if (values === null) {
      return [];
    }

    values
      .sort((a, b) => (a.orderIndex > b.orderIndex ? 1 : -1))
      .forEach(value => {
        let reference: string;
        if (value.reference === null || value.reference.ref === null) {
          reference = null;
        } else {
          reference = value.reference.ref;
        }

        let description: string;
        if (value.reference === null || value.reference.description === null) {
          description = null;
        } else {
          description = value.reference.description;
        }
        treeNodes.push({
          data: {id: optionId, name: null, valueName: value.value, valueDescription: description, reference: reference},
          type: 'reference',
          children: []
        });
      });
    return treeNodes;
  }

  /**
   *  Change the order of the categories in the tree view and emit an event with the new order.
   * @param move
   * @param rowNode
   */
  onChangeCategoryOrder(move: string, rowNode: any): void {
    const parentNode = rowNode.node.parent;
    const category = rowNode.node.data?.category;
    // Ignore No Category (-)
    if (!parentNode || !category || category === '-') {
      return;
    }
    // Remove No Category (_) and keep only movable categories
    const categories = parentNode.children.filter(
      (node: any) => node.data?.category && node.data.category !== '-'
    );
    // Find the current position of selected category
    const currentIndex = categories.findIndex(
      (node: any) => node.data.category === category
    );
    if (currentIndex === -1) return;
    const newIndex = move === 'up' ? currentIndex - 1 : currentIndex + 1;

    // Prevent moving outside range
    if (newIndex < 0 || newIndex >= categories.length) {
      return;
    }

    const payload: CategoryOrderUpdatePayload = {
      rangeId: this.selectedRange.id,
      componentRef: parentNode.data.componentReference,
      category: {
        categoryId: category,
        categoryOrderIndex: newIndex
      }
    };
    this.changeCategoryOrderEvent.emit(payload);
  }
  isNoCategory(rowData: any): boolean {
    return rowData.category !== null  && rowData.category !== undefined && rowData.category !== '-';
  }

  isCategoryFirst(rowNode: any): boolean {
    const categories = rowNode.node.parent.children.filter(
      (node: any) => node.data.category !== '-'
    );
    return categories[0] === rowNode.node;
  }

  isCategoryLast(rowNode: any): boolean {
    const categories = rowNode.node.parent.children.filter(
      (node: any) => node.data.category !== '-'
    );
    return categories[categories.length - 1] === rowNode.node;
  }
  onChangeOptionOrder(move: string, rowNode: any) {
    const optionNode = rowNode.node;
    const categoryNode = optionNode.parent;
    const componentNode = categoryNode?.parent;

    if (!categoryNode || !componentNode) return;

    const options = categoryNode.children;
    const currentIndex = options.indexOf(optionNode);

    const newIndex = move === 'up' ? currentIndex - 1 : currentIndex + 1;

    // prevent moving outside the list
    if (newIndex < 0 || newIndex >= options.length) return;

    // swap options
    [options[currentIndex], options[newIndex]] = [options[newIndex], options[currentIndex]];

    // update order index
    options.forEach((option, index) => {
      option.data.orderIndex = index;
    });

    categoryNode.children = [...options];

    this.changeOptionOrderEvent.emit({
      rangeId: this.selectedRange.id,
      componentRef: componentNode.data.componentReference,
      categoryId: categoryNode.data.category === '-' ? null : categoryNode.data.category,
      optionId: optionNode.data.id,
      orderIndex: newIndex
    });
  }
  canMoveUp(rowNode: any): boolean {
    const options = rowNode.node.parent?.children || [];
    const index = options.indexOf(rowNode.node);
    return index > 0;
  }
  canMoveDown(rowNode: any): boolean {
    const options = rowNode.node.parent?.children || [];
    const index = options.indexOf(rowNode.node);
    return index < options.length - 1;
  }
}
